import Response from '@/shared/types/response';
import chunkArray from '@/shared/utils/chunkArray';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

type UpdateInventory = {
  inventoryId: string;
  inventoryItemsIdList: string[];
  metadataDetails: Record<string, unknown>;
  onUnauthorized?: () => void;
  onProgress?: (progress: number) => void;
};

const updateInventoryAtoms = async ({
  inventoryId,
  inventoryItemsIdList,
  metadataDetails,
  onUnauthorized,
  onProgress,
}: UpdateInventory) => {
  const token = getCookie('auth_token');
  const chunks = chunkArray(inventoryItemsIdList, 5);

  const responses: Response<unknown>[] = [];

  let finishedRequests = 0;
  const totalRequests = inventoryItemsIdList.length;

  for (const chunk of chunks) {
    const promises = chunk.map((inventoryItemId) => {
      return fetcher<Response<unknown>>({
        url: `/inventory/${inventoryId}/atoms/${inventoryItemId}/`,
        method: 'PUT',
        token,
        // TODO: The property 'is_externally_reserved' is currently set to false as a temporary measure.
        // Once the issue tracked by https://waveinc.atlassian.net/browse/BRABF-56 is resolved, this property should be removed.
        body: metadataDetails,
        onUnauthorized,
      })
        .then((response) => {
          finishedRequests++;

          if (onProgress) {
            onProgress((finishedRequests / totalRequests) * 100);
          }

          return response;
        })
        .catch((error) => {
          console.error(
            'Error occurred in function "updateInventory" in file "src/shared/api/inventory/updateInventory.ts":',
            error,
          );
          return {
            ...error,
            data: inventoryItemId,
          } as Response<unknown>;
        });
    });

    const results = await Promise.all(promises);
    responses.push(...results);
  }

  return responses;
};

export default updateInventoryAtoms;
